import PropTypes from 'prop-types';
import '../../../styles/reports.css';
import PropertiesTable from './PropertiesTable';
import QuestionsTable from './QuestionsTable';
import TotalsTable from './TotalsTable';
import StudentsTable from './StudentsTable';

const GrowthReportTable = ({
  persistData,
  growthReport
}) => {
  const getColspanValue=()=>{
    if(persistData.growth){
      if(persistData.midTestID > 0)
        return 9;
      else
        return 5;
    }
    else if(persistData.midTestID > 0)
      return 6;
    else
      return 4;
  };

  return (
    <>
      {growthReport.totals &&
      <TotalsTable
        data={growthReport.totals}
        persistData={persistData}
        colSpan={getColspanValue()}
      />
      }

      {growthReport.students && persistData.students &&
      <StudentsTable
        data={growthReport.students}
        persistData={persistData}
      />
      }

      {growthReport.topics?.length > 0 && persistData.topics &&
      <PropertiesTable
        header={'Topics'}
        data={growthReport.topics}
        persistData={persistData}
      />
      }

      {growthReport.standards?.length > 0 && persistData.standards &&
      <PropertiesTable
        header={'Standards'}
        data={growthReport.standards}
        persistData={persistData}
      />
      }

      {growthReport.attributes?.length > 0 && persistData.bloom &&
      <PropertiesTable
        header={'Attributes'}
        data={growthReport.attributes}
        persistData={persistData}
      />
      }

      {growthReport.questions && persistData.questions &&
      <QuestionsTable
        data={growthReport.questions}
        persistData={persistData}
      />
      }
    </>
  );
};

GrowthReportTable.propTypes = {
  persistData: PropTypes.object,
  growthReport: PropTypes.object
};
  
export default GrowthReportTable;